import { render, staticRenderFns } from "./platuserprocess-add-or-update.vue?vue&type=template&id=65204e40&"
import script from "./platuserprocess-add-or-update.vue?vue&type=script&lang=js&"
export * from "./platuserprocess-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports